import { type ReactNode, useState } from "react";
import "./media-switcher.css";

export function MediaSwitcher({
  items,
}: { items: ReadonlyArray<{ id: string; label: string; content: ReactNode }> }) {
  const [selected, setSelected] = useState(0);
  return (
    <div className="media-switcher" data-multiple={items.length > 1}>
      {items.map((item, index) => (
        <div key={item.id} hidden={selected !== index} className="media-switcher-panel">
          {item.content}
          {items.length > 1 && selected === index && (
            <button
              className="media-switcher-next"
              type="button"
              aria-label={`Next image: ${items[(selected + 1) % items.length]?.label}`}
              title="Next image"
              onClick={() => setSelected((current) => (current + 1) % items.length)}
            >
              <span className="media-switcher-fold" aria-hidden="true" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
